import { createAction, props } from '@ngrx/store';

import { Site } from 'src/app/model/site';
import { User } from 'src/app/model/user';

export const getSitesData = createAction('[SiteList] GET_SITES_DATA');
export const getSitesDataSuccess = createAction('[SiteList] GET_SITES_DATA_SUCCESS', props<{ sites: Site[] }>());
export const getSitesDataFailed = createAction('[SiteList] GET_SITES_DATA_FAILED', props<{ errorMessage: string }>());

export const getSiteOwner = createAction('[SiteList] GET_SITE_OWNER', props<{ site: Site }>());
export const getSiteOwnerSuccess = createAction('[SiteList] GET_SITE_OWNER_SUCCESS', props<{ siteId: number; user: User }>());
export const getSiteOwnerFailed = createAction('[SiteList] GET_SITE_OWNER_FAILED', props<{ errorMessage: string }>());

export const deleteSite = createAction('[SiteList] DELETE_SITE', props<{ siteId: number }>());
export const deleteSiteSuccess = createAction('[SiteList] DELETE_SITE_SUCCESS', props<{ message: string; siteId: number }>());
export const deleteSiteFailed = createAction('[SiteList] DELETE_SITE_FAILED', props<{ errorMessage: string }>());
